"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as h } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: r, size: c = 24 } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = n(), e = r !== null && r !== void 0 ? r : t ? h.colors.inverse : h.colors.neutralHigh, { skinName: o } = i();
    return o.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M5.928 3.5h12.144c2.168 0 3.933 1.826 3.928 4.064v5.915c0 2.238-1.76 4.064-3.928 4.064h-9.14L6.179 20.39a.35.35 0 0 1-.388.08.37.37 0 0 1-.22-.34v-2.607C3.573 17.339 2 15.594 2 13.479V7.564C2 5.326 3.76 3.5 5.928 3.5m.686 9.245c.274.123.567.18.905.18.914 0 1.55-.615 1.55-1.51 0-.945-.767-1.295-1.274-1.527h-.002c-.461-.209-.461-.327-.461-.403 0-.255.448-.265.498-.265.036 0 .229.005.416.057.283.08.58-.095.658-.388a.56.56 0 0 0-.375-.681 2.7 2.7 0 0 0-.7-.095c-.927 0-1.572.568-1.572 1.377 0 .918.8 1.282 1.102 1.42.608.279.64.378.64.515 0 .095 0 .388-.48.388-.192 0-.348-.028-.485-.09a.53.53 0 0 0-.704.294c-.114.283.01.61.284.728m7.709-.374V8.676a.55.55 0 0 0-.412-.54.53.53 0 0 0-.603.294L12 11.137 10.692 8.43a.535.535 0 0 0-.603-.293.55.55 0 0 0-.412.54v3.694c0 .308.238.554.535.554a.54.54 0 0 0 .535-.554v-1.348l.773 1.595c.091.189.274.307.48.307a.53.53 0 0 0 .48-.308l.773-1.594v1.348c0 .308.238.554.535.554a.54.54 0 0 0 .535-.554m.95.374c.275.123.568.18.906.18.915 0 1.555-.615 1.55-1.51 0-.945-.767-1.295-1.274-1.527h-.001c-.462-.209-.462-.327-.462-.403 0-.255.448-.265.498-.265.037 0 .229.005.416.057.284.08.581-.095.659-.388a.56.56 0 0 0-.375-.681 2.7 2.7 0 0 0-.7-.095c-.928 0-1.573.568-1.573 1.377 0 .918.8 1.282 1.102 1.42.608.279.64.378.64.515 0 .095 0 .388-.48.388-.192 0-.347-.028-.484-.09a.53.53 0 0 0-.705.294c-.114.283.01.61.284.728"
        })
    })) : o.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M5.928 3.5h12.144c2.168 0 3.933 1.826 3.928 4.064v5.915c0 2.238-1.76 4.064-3.928 4.064h-9.14L6.179 20.39a.35.35 0 0 1-.388.08.37.37 0 0 1-.22-.34v-2.607C3.573 17.339 2 15.594 2 13.479V7.564C2 5.326 3.76 3.5 5.928 3.5m.686 9.245c.274.123.567.18.905.18.914 0 1.55-.615 1.55-1.51 0-.945-.767-1.295-1.274-1.527h-.002c-.461-.209-.461-.327-.461-.403 0-.255.448-.265.498-.265.036 0 .229.005.416.057.283.08.58-.095.658-.388a.56.56 0 0 0-.375-.681 2.7 2.7 0 0 0-.7-.095c-.927 0-1.572.568-1.572 1.377 0 .918.8 1.282 1.102 1.42.608.279.64.378.64.515 0 .095 0 .388-.48.388-.192 0-.348-.028-.485-.09a.53.53 0 0 0-.704.294c-.114.283.01.61.284.728m7.709-.374V8.676a.55.55 0 0 0-.412-.54.53.53 0 0 0-.603.294L12 11.137 10.692 8.43a.535.535 0 0 0-.603-.293.55.55 0 0 0-.412.54v3.694c0 .308.238.554.535.554a.54.54 0 0 0 .535-.554v-1.348l.773 1.595c.091.189.274.307.48.307a.53.53 0 0 0 .48-.308l.773-1.594v1.348c0 .308.238.554.535.554a.54.54 0 0 0 .535-.554m.95.374c.275.123.568.18.906.18.915 0 1.555-.615 1.55-1.51 0-.945-.767-1.295-1.274-1.527h-.001c-.462-.209-.462-.327-.462-.403 0-.255.448-.265.498-.265.037 0 .229.005.416.057.284.08.581-.095.659-.388a.56.56 0 0 0-.375-.681 2.7 2.7 0 0 0-.7-.095c-.928 0-1.573.568-1.573 1.377 0 .918.8 1.282 1.102 1.42.608.279.64.378.64.515 0 .095 0 .388-.48.388-.192 0-.347-.028-.484-.09a.53.53 0 0 0-.705.294c-.114.283.01.61.284.728"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M21.841 6.134c0-1.74-1.468-3.154-3.272-3.154H5.43c-1.806 0-3.274 1.415-3.274 3.154v8.765a3.11 3.11 0 0 0 2.053 2.955v1.686c0 .804.717 1.485 1.569 1.485.66 0 1.07-.353 1.291-.639l1.888-2.333h9.613c1.804 0 3.272-1.415 3.272-3.154zM5.872 9.092c0 .44.286.594.983.863.69.266 1.633.63 1.633 1.835 0 1.064-.75 1.675-2.056 1.675-.557 0-1.106-.113-1.406-.222a.384.384 0 0 1-.246-.453l.053-.21a.4.4 0 0 1 .193-.247.4.4 0 0 1 .32-.034q.533.165 1.08.166c.466 0 .695-.087.805-.16.103-.064.22-.207.22-.507 0-.48-.293-.639-1.016-.919l-.005-.002c-.67-.26-1.586-.617-1.586-1.754 0-.49.174-.9.504-1.18.55-.47 1.53-.546 2.588-.246.205.053.328.26.278.465l-.054.205a.405.405 0 0 1-.5.28 3 3 0 0 0-.883-.132c-.905 0-.905.39-.905.577m8.317-1.479a.394.394 0 0 1 .4.39v4.969c0 .215-.18.389-.4.389h-.21a.395.395 0 0 1-.401-.39V9.989l-1.129 2.068a.4.4 0 0 1-.356.207h-.227a.4.4 0 0 1-.355-.21l-1.076-2.025v2.944c0 .215-.18.389-.4.389h-.213a.396.396 0 0 1-.401-.39V8c0-.216.18-.39.4-.39h.227a.4.4 0 0 1 .356.21l1.588 2.986 1.63-2.986a.4.4 0 0 1 .356-.207zm2.422 1.479c0 .44.283.594.98.863.69.266 1.634.63 1.634 1.835 0 1.064-.75 1.675-2.056 1.675-.558 0-1.107-.113-1.406-.222a.384.384 0 0 1-.247-.453l.053-.21a.4.4 0 0 1 .194-.247.4.4 0 0 1 .319-.034c.356.11.72.166 1.081.166.465 0 .695-.087.804-.16.107-.064.224-.207.224-.507 0-.48-.294-.639-1.017-.919l-.005-.002c-.669-.26-1.586-.617-1.586-1.754 0-.49.174-.9.505-1.18.549-.47 1.53-.546 2.588-.246.204.053.328.26.277.465l-.053.205a.4.4 0 0 1-.188.243.4.4 0 0 1-.313.037 3 3 0 0 0-.883-.132c-.904 0-.904.39-.904.577"
        })
    }));
}, p = v;
export { p as default };
